$("#Contact_popup-newsletter,#customer_login,#ContactForm82015387848,#ContactForm82015322312,#out-of-stock-form form,#RegisterForm").validate();

window.onscroll = function() {
  stickyHeader()
  
};
var header = document.querySelector(".site-header");
var sticky = header.offsetTop;
function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("fixed-header");
  } else {
    header.classList.remove("fixed-header");
  }
}
 
   var swiper = new Swiper(".featured_product_slider", {
        slidesPerView: 2,
        spaceBetween: 10, 
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }, 
        breakpoints: {
          "@0.00": {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          "@0.75": {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          "@1.00": {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          "@1.50": {
            slidesPerView: 2,
            spaceBetween: 50,
          },
        },
          
     

      });


$("#open_filters").on("click",function(){
   $("#collection_filters").slideToggle(200);
});


$(" #collection_filters ul li:first-of-type").on("click",function(){
  $(this).nextAll("li").toggleClass("d-flex");
  let openLiLength = $("#collection_filters li.d-flex").length;
  openLiLength > 0 ? $("#collection_filters .page-width.jc_c").show() : $("#collection_filters .page-width.jc_c").hide()
     
       
})


$(".product-form__controls-group .btn-quantity button").on("click",function(){
  let quantityInput = $(".btn-quantity input");
  let btnType = $(this).data("type");
      let i = Number(quantityInput.val());
      btnType == "+" ? i++ :  i--
      
      console.log(i);
      i >0 && i<=100 ? quantityInput.val(i) : ""
  
});

$(".cart .btn-quantity button").on("click",function(){
   let getInput = $(this).attr("for");
   let lineIndex = $(this).data("index");
   let quantityInput = $("input[id='"+getInput+"']");
   let btnType = $(this).data("type");
      let i = Number(quantityInput.val());
      btnType == "+" ? i++ :  i--
      
      console.log(i);
      i >0 && i<=100 ? quantityInput.val(i) : ""
      
      let quantityIndex = $("input[id='"+getInput+"']").val();
     location.href="/cart/change?line="+lineIndex+"&quantity="+quantityIndex;
});

$(".tab-container button").on("click",function(){
   let openTab = $(this).data("href");
  $(".tab-container button").removeClass("tab-active") ;
   $(this).addClass("tab-active") ;
  $(".tab-container > div:not(:first-of-type)").slideUp();
  $(".tab-container > div#tab_"+openTab).slideDown();
});


 
    var $notify_form = $('#out-of-stock-form .contact-form');
   
    $notify_form.each(function() {
      var $nf = $(this);
      $nf.on("submit", function (e) {
         var $email_field = $('#out-of-stock-form .contact-form input[type=email]');
        setTimeout(function(){
          if($("#out-of-stock-form input.error").length == 0){ 
        $('#out-of-stock-form .contact-form button').text("Sending...").attr("disabled",true);
        if($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function(){
                $('.stock_text:not(.hide)').html($(".stock_text.hide").html());
                 $('#out-of-stock-form .contact-form button').text("Send").attr("disabled",false); 
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      }
        },1000)
      });
    }); 
 